import React from 'react';
import { ShimmerTable } from 'react-shimmer-effects';

function ItemShimmer({classkey}) {
    return (
        <div className={classkey?classkey:''}>  
            <div className="w-full table-auto border border-[#ededed] rounded">
                <ShimmerTable row={10} col={7} />
            </div>
        </div>
    );
}

export default ItemShimmer;